import aboutJson from './content/about.json';

export const aboutMock = {
    layoutType: 2,
    data: {
        name: 'about',
        areasList: [
            {
                id: 1,
                name: 'AboutPage',
                componentName: 'Comp:AboutPage',
                content: JSON.stringify(aboutJson)
            }
        ]
    }
};
